import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/plugins/vue-ls'
import '@/i18n'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './assets/style/element-theme.scss'

import './assets/style/global.scss';
import './assets/style/common.scss';
import permissionDirective from '@/directives/permission';
import dialogDragDirective from '@/directives/dialogDrag';
import { Icon } from 'ant-design-vue';
import { getBranding } from '@/config/branding';
Vue.use(Icon);

const browserIcon = getBranding().logos && getBranding().logos.browserIcon;
if (browserIcon) {
  const iconLink = document.querySelector('link[rel~="icon"]') || document.createElement('link');
  iconLink.rel = 'icon';
  iconLink.href = browserIcon;
  if (!iconLink.parentNode) {
    document.head.appendChild(iconLink);
  }
}
Vue.use(ElementUI);

// 先保存原始 Message
const $msg = ElementUI.Message

// 全局包装，默认 showClose: true
Vue.prototype.$message = (options) => {
  return $msg({
    showClose: true,
    duration: 3000,
    ...options
  })
}

// 挂载四个类型方法
Vue.prototype.$message.success = (msg) => $msg.success({ message: msg, showClose: true })
Vue.prototype.$message.warning = (msg) => $msg.warning({ message: msg, showClose: true })
Vue.prototype.$message.info = (msg) => $msg.info({ message: msg, showClose: true })
Vue.prototype.$message.error = (msg) => $msg.error({ message: msg, showClose: true })

Vue.prototype.$store = store;
Vue.config.productionTip = false
Vue.prototype.aiEnabled = process.env.VUE_APP_AI_ENABLED === "true"

Vue.directive('permission', permissionDirective);
Vue.directive('dialog-drag', dialogDragDirective);

Vue.directive('resize', {
  inserted(el, binding) {
    window.addEventListener('resize', () => {
      // 当页面大小发生改变时触发的回调函数
      if (binding.value && typeof binding.value === 'function') {
        binding.value()
      }
    })
  },
})

// 根据环境变量控制是否启用反调试（禁用开发者工具，含右键、F12、菜单等）
if (process.env.VUE_APP_DISABLE_F12 === 'true') {
  // 动态引入，避免未启用时增加首屏体积
  import('@/utils/antiDebug').then(({ initAntiDebug }) => {
    initAntiDebug(process.env.VUE_APP_ANTI_DEBUG_KEY)
  })
}

// 已登录时初始化公共数据；图片前缀优先从 localStorage 缓存恢复。
if (Vue.ls.get('ACCESS_TOKEN')) {
  store.dispatch('app/initializeAfterLogin').catch(() => { })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// 回到顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
